// Copyright (c) 2023 Jürgen Gebath
//
// This software is released under the MIT License.
// https://opensource.org/licenses/MIT

import { Grid, Typography, Link } from "@mui/material";
import Contact from "../components/Contact";

export default function Law() {
  return (
    <Grid
      container
      spacing={2}
      sx={(theme) => ({
        [theme.breakpoints.down("sm")]: {
          marginTop: 7,
        },
        [theme.breakpoints.up("sm")]: {
          marginTop: 20,
        },
      })}>
      <Grid
        item
        xs={12}>
        <Typography
          id="Impressum"
          variant="h4">
          Impressum
        </Typography>
        <Contact sx={{ marginY: 5 }} />
        <Typography
          variant="body1"
          sx={(theme) => ({ color: theme.palette.primary.main, marginTop: 2 })}>
          <Link href="https://www.bundesfeuerwehrverband.at/">
            Bundesfeuerwehrverband
          </Link>
          <br />
          <Link href="https://www.noe122.at/">Landesfeuerwehrverband NÖ</Link>
          <br />
          <Link href="http://bfkdo-stpoelten.at/">
            Bezirksfeuerwehrkommando St. Pölten
          </Link>
        </Typography>
        <br />
        <hr />
        <Typography
          variant="h5"
          sx={{ marginTop: 5 }}>
          Informationspflicht laut § 5 E-Commerce Gesetz, § 14
          Unternehmensgesetzbuch, § 63 Gewerbeordnung und Offenlegungspflicht
          laut § 25 Mediengesetz
        </Typography>
        <Typography
          varian="body1"
          sx={{ marginTop: 2 }}>
          Die FF Großrust-Merking prüft und modifiziert regelmäßig die
          Informationen ihrer Website. Dennoch können Daten und Informationen
          bereits ihre Gültigkeit verloren haben. Soweit gesetzlich zulässig
          wird daher die Haftung und Gewährleistung für die Richtigkeit und
          Vollständigkeit der veröffentlichten Information und Daten
          ausgeschlossen. Weiters übernimmt die FF Großrust-Merking auf Grund
          fehlender Einflussmöglichkeit keinerlei Haftung und Gewährleistung für
          Inhalte aller über externe oder weiterführende Links verbundene Sites.
          Diese Erklärung gilt für alle auf der Website angebrachten externen
          Links und allen weiterführenden Links.
        </Typography>
        <br />
        <hr />
        <Typography
          variant="h5"
          sx={{ marginTop: 5 }}>
          Haftungsauschluss
        </Typography>
        <Typography
          varian="body1"
          sx={{ marginTop: 2 }}>
          Dieser Haftungsauschluss ist als Teil des Internetangebotes zu
          betrachten, von dem aus auf diese Webseite verwiesen wurde. Sofern
          Teile oder einzelne Formulierungen dieses Textes der geltenden
          Rechtslage nicht, nicht mehr oder nicht vollständig entsprechen,
          bleiben die übrigen Teile des Dokumentes in ihrem Inhalt und ihrere
          Gültigkeit davon unberührt.
        </Typography>
        <Typography
          variant="h6"
          sx={{ marginTop: 5 }}>
          Haftung für Inhalte dieser Webseite
        </Typography>
        <Typography
          varian="body1"
          sx={{ marginTop: 2 }}>
          Die Inhalte dieser Webseite wurden mit größtmöglicher Sorgfalt
          erstellt. Für die Richtigkeit, Vollständigkeit und Aktualität der
          Inhalte übernehmen wir jedoch keine Gewähr. Als Diensteanbieter sind
          wir für eigene Inhalte auf diesen Seiten nach den allgemeinen Gesetzen
          verantwortlich. Wir sind jedoch nicht verpflichtet, übermittelte oder
          gespeicherte fremde Informationen zu überwachen oder nach Umständen zu
          forschen, die auf eine rechtswidrige Tätigkeit hinweisen.
          Verpflichtungen zur Entfernung oder Sperrung der Nutzer von
          Informationen nach den allgemeinen Gesetzen bleiben hiervon unberührt.
          Eine diesbezügliche Haftung ist jedoch erst ab dem Zeitpunkt der
          Kenntnis einer konkreten Rechtsverletzung möglich. Bei Bekanntwerden
          von entsprechenden Rechsverletzungen werden wir diese Inhalte umgehend
          entfernen.
        </Typography>
        <Typography
          variant="h6"
          sx={{ marginTop: 5 }}>
          Haftung für Links auf Webseiten Dritter
        </Typography>
        <Typography
          variant="body1"
          sx={{ marginTop: 2 }}>
          Unser Angebot enthält Links zu externen Websites. Auf den Inhalten
          dieser externen Webseiten haben wir keinerlei Einfluss. Deshalb können
          wir für diese fremden Inhalte auch keine Gewähr übernehmen. Für die
          Inhalte der verlinkten Seiten ist stets der jeweilige Anbieter oder
          Betreiber der Seiten verantwortlich. Die verlinkten Seiten wurden zum
          Zeitpunkt der Verlinkung auf mögliche Rechtsverstöße überprüft.
          Rechtswidrige Inhalte waren zum Zeitpunkt der Verlinkung nicht
          erkennbar. Eine permanente inhaltliche Kontrolle der verlinkten Seiten
          ist jedoch ohne konkrete Anhaltspunkte einer Rechstverletzung nicht
          zumutbar. Bei Bekanntwerden von Rechsverletzungen werden wir derartige
          Links umgehend enfternen.
        </Typography>
        <Typography
          variant="h6"
          sx={{ marginTop: 5 }}>
          Urheberrecht
        </Typography>
        <Typography
          variant="body1"
          sx={{ marginTop: 2 }}>
          Die Betreiber dieser Website sind bemüht, stets die Urheberrechte
          andere zu beachten bzw. auf selbst erstellte sowie lizenzfreie Werke
          zurückzugreifen. Die durch Seitenbetreiber erstellten Inhalte und
          Werke auf dieser Webseite unterliegen dem Urheberrecht. Beiträge
          Dritter sind als solche gekennzeichnet. Die Vervielfältigung,
          Bearbeitung, Verbreitung und jede Art der Verwertung außerhalb der
          Grenzen des Urheberrechtes bedürfen der schriftlichen Zustimmung des
          jeweiligen Autors bzw. Erstellers. Downloads und Kopien dieser Seite
          sind nur für den privaten, nicht kommerziellen Gebrauch gestattet.
        </Typography>
        <br />
        <hr />
        <Typography
          id="Datenschutz"
          variant="h5"
          sx={{ marginTop: 5 }}>
          Datenschutzerklärung
        </Typography>
        <Typography
          variant="body1"
          sx={{ marginTop: 2 }}>
          Wir legen großen Wert auf den Schutz Ihrer Daten. Um Sie in vollem
          Umfang über die Verwendung personenbezogener Daten zu informieren,
          bitten wir Sie die folgenden Datenschutzhinweise zur Kenntnis zu
          nehmen.
        </Typography>
        <Typography
          variant="h6"
          sx={{ marginTop: 5 }}>
          Persönliche Daten
        </Typography>
        <Typography
          variant="body1"
          sx={{ marginTop: 2 }}>
          Persönliche Daten die Sie auf dieser Webseite elektronisch
          übermitteln, wie zum Beispiel Name, E-Mail-Adresse, Adresse oder
          andere persönliche Angaben, werden von uns nur zum jeweils angegeben
          Zweck verwendet, sicher verwahrt und nicht an Dritte weitergegeben.
          Der Provider erhebt und speichert automatisch Informationen am
          Webserver wie verwendeter Browser, Betriebssystem, Verweisseite,
          IP-Adresse, Uhreit des Zugriffs usw. Diese Daten können ohne Prüfung
          weiterer Datenquellen keinen bestimmten Personen zugeordnet werden und
          wir werten diese Daten auch nicht weiter aus solange keine
          rechtswidrige Nutzung userer Webseite vorliegt.
        </Typography>
        <Typography
          variant="h6"
          sx={{ marginTop: 2 }}>
          Formulardaten und Kommentare
        </Typography>
        <Typography
          variant="body1"
          sx={{ marginTop: 2 }}>
          Wenn Webseitenbesucher Kommentare oder Formulareinträge hinterlassen,
          werden die eingegebenen Daten und ihre IP-Adressen gespeichert. Das
          erfolgt zur Sicherheit, falls jemand widerrechtliche Inhalte verfasst
          (Beleidigungen, links- oder rechtsextreme Propaganda, Hasspostings
          usw.). In diesem Fall sind wir an der Identität des Verfassers
          interessiert.
        </Typography>
        <Typography
          variant="h6"
          sx={{ marginTop: 5 }}>
          Cookies
        </Typography>
        <Typography
          variant="body1"
          sx={{ marginTop: 2 }}>
          Cookies sind kleine Dateien, die es dieser Webseite ermöglichen auf
          dem Computer des Besuchers spezifische, auf den Nutzer bezogene
          Informationen zu speichern, während unsere Website besucht wird.
          Cookies helfen uns dabei, die Nutzungshäufigkeit und die Anzahl der
          Nutzer unserer Internetseiten zu ermitteln, sowie unsere Angebote für
          Sie komfortabel und effizient zu gestalten. Wir verwenden einerseits
          Session-Cookies, die ausschließlich für die Dauer Ihrere Nutzung
          unserer Website zwischengespeichert werden und zum anderen permanente
          Cookies, um Informatioen über Besucher wiederzuerkennen und bei
          wiederholter Nutzung eine möglichst attraktive Webseite und
          interessante Inhalte präsentieren zu können. Der Inhalt eines
          permanenten Cookies beschränkt sich auf eine Identifikationsnummer.
          Name, IP-Adresse usw. werden nicht gespeichert. Eine
          Einzelprofilbildung über Ihr Nutzungverhalten findet nicht statt. Eine
          Nutzung unserer Angebote ist auch ohne Cookies möglich. Sie können in
          Ihrem Browser das Speichern von Cookies deaktivieren, auf bestimmte
          Webseiten beschränken oder Ihren Webbrowser (Chrome, IE, Firefox, ...)
          so einstellen, dass er sie benachrichtigt, sobald ein Cookie gesendet
          wird. Sie können Cookies auch jederzeit von der Festplatte ihres PC
          löschen. Bitte beachten Sie aber, dass Sie in diesem Fall mit einer
          eingeschränkten Darstellung der Seite und mit einer eingeschränkten
          Benutzführung rechnen müssen.
        </Typography>
        <br />
      </Grid>
    </Grid>
  );
}
